﻿var mmsystem = mmsystem || {};
mmsystem.ui = mmsystem.ui || {};
mmsystem.ui.content = mmsystem.ui.content || {};

mmsystem.payments = mmsystem.payments || {}

//Requires https://js.stripe.com/v3/

mmsystem.utilities = require('mmsystem-utilities');
mmsystem.plugins = require('mmsystem-plugins');
mmsystem.ui.ajax = require('mmsystem-ui-ajax');
mmsystem.payments.stripe = require('mmsystem-payments-stripe');
var events = require('events');
var jQueryValidation = require('jquery-validation');

mmsystem.ui.content.orders = {

    EventEmitter: new events.EventEmitter(),

    Settings: {},
    Order: {},
    User: {},
    LocalisedStrings: new Array(),
    Language: "En",
    LanguageUrlPrefix: "En",
    UseGlobalization: false,
    Urls: {
        GetGenericSettingsUrl: "/Orders/APIGetCheckoutDetails",
        GetDeliveryMethodsUrl: "/Orders/APIGetDeliveryMethods",
        CompleteOrderUrl: "/Orders/Complete",
        SubmitEnqiure: "/Page/SubmitContact"
    },
    IsPaymentResponseEvent: false,
    IsStripeRequestInProgress: false,
    IsPayPalRequestInProgress: false,
    UseSameAddressForShippingAndBilling: true,
    FirstLoad: true,
    IsServerError: false,
    
    //Sections
    Checkout: {
        Init: function (settings) {
            mmsystem.ui.content.orders.AddGenericListeners();
            this.AddListeners();
            mmsystem.ui.content.orders.Validation.Init(mmsystem.ui.content.orders.DomElements.Form.GetContactInfoForm(), mmsystem.ui.content.orders.Validation.Rules.GetCheckoutRules());
            //mmsystem.plugins.AjaxCover.ShowOnElement();

            //On Basket ready
            mmsystem.plugins.Basket.EventEmitter.on("BasketInitComplete", function (param) {
                mmsystem.ui.content.orders.GetGenericSettings();
            });
        },

        AddListeners: function () {
            //Continue button
            mmsystem.ui.content.orders.DomElements.CompleteOrderCheckoutButton().click(function () {
                
                if (mmsystem.ui.content.orders.Validation.Form.valid()) {
                    mmsystem.plugins.AjaxCover.ShowOnElement();
                }           

            });
        },

    },

    Details: {
        Init: function (settings) {
            mmsystem.ui.content.orders.AddGenericListeners();
            this.AddListeners();
            mmsystem.ui.content.orders.DomElements.Form.CheckCountry('delivery');
            mmsystem.ui.content.orders.Validation.Init(mmsystem.ui.content.orders.DomElements.Form.GetOrderDetailsForm(), mmsystem.ui.content.orders.Validation.Rules.DeliveryAddressRules);
            //mmsystem.plugins.AjaxCover.ShowOnElement();
            //On Basket ready
            mmsystem.plugins.Basket.EventEmitter.on("BasketInitComplete", function (param) {
                mmsystem.ui.content.orders.GetGenericSettings();
                mmsystem.ui.content.orders.DomElements.Form.CheckDeliveryMethods();
            });
        },

        AddListeners: function () {
            //Continue button
            console.log("mmsystem.ui.content.orders.Details.AddListeners()");
            
            mmsystem.ui.content.orders.DomElements.CompleteOrderDetailsButton().click(function () {

                if (mmsystem.ui.content.orders.Validation.Form.valid()) {
                    mmsystem.plugins.AjaxCover.ShowOnElement();
                }

            });

            //On Get Delivery Methods Complete
            mmsystem.ui.ajax.EventEmitter.on('OrderGetDeliveryMethods', function (param) {
                console.log('mmsystem.ui.ajax.EventEmitter: OrderGetDeliveryMethods');
                var result = param; // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                console.log(param);
                if (result && result.Type == 1) {
                    //console.log("show success");
                    if (result.Object && result.Object.RawHtml) {
                        mmsystem.ui.content.orders.DomElements.Form.RefreshDeliveryMethods(result.Object.RawHtml);
                    }
                }

                mmsystem.plugins.AjaxCover.Hide();

            });

            
            //On Order Update Complete
            mmsystem.ui.ajax.EventEmitter.on("orderUpdateComplete", function (param) {
                console.log("mmsystem.ui.content.orders.Details ... on orderUpdateComplete");
                var result = param.responseJSON; // SimpleResult { Type: '0', Message: '' } success - 1, error - 2
                if (result && result.Type == 1) {
                    //Get updated deliveries
                    mmsystem.ui.content.orders.DomElements.Form.CheckDeliveryMethods();
                } 
            });


            this.AddCountryListeners();
            this.AddDeliveryMethodListeners();
        },

        AddCountryListeners: function () {
            //Country Select
            mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.CountrySelectOption().click(
                function () {
                    mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.CountryISO().val($(this).data('value'));
                    mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.Country().val($(this).text()).text($(this).text()).valid();
                    mmsystem.ui.content.orders.DomElements.Form.CheckDeliveryMethods();
                });
            mmsystem.ui.content.orders.DomElements.Form.BillingAddress.CountrySelectOption().click(
                function () {
                    mmsystem.ui.content.orders.DomElements.Form.BillingAddress.CountryISO().val($(this).data('value'));
                    mmsystem.ui.content.orders.DomElements.Form.BillingAddress.Country().val($(this).text()).text($(this).text()).valid();
                });
            //Country autofill fix & delivery methods
            mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.Country().on('change',
                function () {
                    mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.CountryISO().val(mmsystem.ui.content.orders.DomElements.Form.FindCountryCode($(this)));
                    mmsystem.ui.content.orders.DomElements.Form.CheckDeliveryMethods();
                });
            mmsystem.ui.content.orders.DomElements.Form.BillingAddress.Country().on('change',
                function () {
                    mmsystem.ui.content.orders.DomElements.Form.BillingAddress.CountryISO().val(mmsystem.ui.content.orders.DomElements.Form.FindCountryCode($(this)));
                });
        },

        AddDeliveryMethodListeners: function () {

            //Method Select
            mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.DeliverySelectOption().click(
                function () {
                    mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.DeliveryPriceId().val($(this).data('value'));
                    mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.DeliveryPrice().val($(this).text()).text($(this).text()).valid();
                    $('.select').removeClass('active');
                    //Update Basket
                    mmsystem.ui.content.orders.Details.UpdateBasketOrderDelivery($(this));
                });

            
        },

        UpdateBasketOrderDelivery: function (element) {
            mmsystem.plugins.Basket.Order.Delivery = mmsystem.plugins.Basket.Order.Delivery || {};
            mmsystem.plugins.Basket.Order.Delivery.Price = element.data('delivery-price');
            mmsystem.plugins.Basket.Order.Delivery.PriceString = element.data('delivery-price-string');
            mmsystem.plugins.Basket.Order.Delivery.Name = element.data('delivery-price-title');
            mmsystem.plugins.Basket.Order.PriceTotal = parseFloat(mmsystem.plugins.Basket.Order.Price) + parseFloat(mmsystem.plugins.Basket.Order.Delivery.Price);
            mmsystem.plugins.Basket.Order.PriceTotalString = mmsystem.utilities.DisplayPrice(mmsystem.plugins.Basket.Order.PriceTotal, mmsystem.plugins.Basket.Order.Currency)

            mmsystem.plugins.Basket.Order = mmsystem.plugins.Basket.Order;
            console.log(mmsystem.plugins.Basket.Order);
            mmsystem.plugins.Basket.UpdateBasketValues();
        }
    },

    Payments: {
        Init: function (settings) {
            
            this.AddListeners();
            mmsystem.ui.content.orders.Validation.Init(mmsystem.ui.content.orders.DomElements.Form.GetOrderPaymentsForm());
            //mmsystem.plugins.AjaxCover.ShowOnElement();
            //On Basket ready
            mmsystem.plugins.Basket.EventEmitter.on("BasketInitComplete", function (param) {
                mmsystem.ui.content.orders.AddGenericListeners(true);
                mmsystem.ui.content.orders.GetGenericSettings();
            });
        },

        AddListeners: function () {

            mmsystem.ui.content.orders.DomElements.Form.UseShippingAddressForBillingAddress().change(
                function () {
                    if ($(this).is(':checked')) {
                        mmsystem.ui.content.orders.UseSameAddressForShippingAndBilling = true;
                        mmsystem.ui.content.orders.Validation.ClearRules();
                        
                    }
                });

            mmsystem.ui.content.orders.DomElements.Form.UseDifferentAddressForBillingAddress().change(
                function () {
                    if ($(this).is(':checked')) {
                        mmsystem.ui.content.orders.UseSameAddressForShippingAndBilling = false;
                        mmsystem.ui.content.orders.Validation.SetRules(mmsystem.ui.content.orders.Validation.Rules.BillingAddressRules);
                    }
                });
        },

    },

    AddGenericListeners: function (initStripe) {

        //On Generic Settings Complete
        mmsystem.ui.ajax.EventEmitter.on('getCheckoutDetailsComplete', function (param) {
            //console.log('mmsystem.ui.ajax.EventEmitter: getCheckoutDetailsComplete');
            var result = param.responseJSON;
            //console.log(result);
            //Set Settings
            mmsystem.ui.content.orders.Settings = result.Object.Settings;
            //Set Order - update User
            mmsystem.plugins.Basket.Order = result.Object.Order;
            //Set Stripe Configuration
            mmsystem.ui.content.orders.Settings.Stripe = result.Object.Stripe;
            if (initStripe)
                mmsystem.ui.content.orders.InitStripePayment();

            mmsystem.plugins.AjaxCover.Hide();

        });

        //Submit Enquire
        mmsystem.ui.content.orders.DomElements.SubmitEnquireButton().click(function () {
            if (mmsystem.ui.content.orders.Validation.Form.valid()) {
                //console.log('send enquire');
                var data = mmsystem.ui.content.orders.DomElements.Form.GetEnquireData();
                //console.log(data);
                mmsystem.ui.ajax.SubmitEnquire(mmsystem.ui.content.orders.Urls.SubmitEnqiure, data);
                mmsystem.plugins.AjaxCover.ShowOnButton($(this).attr('id'));
            }
        });

        mmsystem.ui.ajax.EventEmitter.on('submitEnquireComplete', function (param) {
            //console.log('mmsystem.ui.ajax.EventEmitter: submitEnquireComplete');
            var result = param.responseJSON;
            if (result && result.Type == 1) {
                mmsystem.ui.content.orders.DomElements.SubmitEnquireButton().attr("disabled", "disabled");
                $('.equire-response-message').removeClass('d-none').addClass('text-success').text('success');
            }

            if (result && result.Message)
                $('.equire-response-message').text(result.Message);
            
            mmsystem.plugins.AjaxCover.Hide();

        });

        //Server Error
        mmsystem.ui.ajax.EventEmitter.on("serverError", function (e, param) {
            console.log('Server Error');
            mmsystem.plugins.AjaxCover.Hide();
            mmsystem.utilities.IsServerError = true;
            mmsystem.utilities.RedirectToUrlTimer("/Products", 10000, mmsystem.ui.content.orders.DomElements.ErrorElement());
        });

    },

    GetGenericSettings: function () {
        mmsystem.ui.ajax.GetCheckoutDetails(mmsystem.ui.content.orders.Urls.GetGenericSettingsUrl, { orderId: mmsystem.plugins.Basket.Order.Id} );
    },

    Validation: {
        Form: {},
        Validator: {},

        Init: function (form, rules) {
            this.Form = form;
            this.Validator = form.validate();
            
            //Setup rules
            if (rules)
                this.Validator.settings.rules = rules;

            //console.log(this.Validator);
            //console.log(this.Form);
        },
        
        ClearRules: function () {
            //console.log(this.Validator);
            this.Validator.settings.rules = {};
        },
        SetRules: function (rules) {
            //console.log(this.Validator);
            this.Validator.settings.rules = rules;
        },
        AppendRules: function (rules) {
            this.Validator.settings.rules.push(rules);
        },
        Rules: {
            EmailRules: {
                email: {
                    required: true,
                    email: true
                }
            },
            PolicyRules: {
                dataAgree: {
                    required: true
                }
            },

            DeliveryAddressRules: {
                'DeliveryAddress.FirstName': { required: true },
                'DeliveryAddress.LastName': { required: true },
                'DeliveryAddress.PhoneNumber': { required: true },
                'DeliveryAddress.Street': { required: true },
                'DeliveryAddress.City': { required: true },
                'DeliveryAddress.PostCode': { required: true },
                'DeliveryAddress.Country': { required: true },
                'DeliveryAddress.DeliveryPrice': { required: true }
            },
            BillingAddressRules: {
                'BillingAddress.FirstName': { required: true },
                'BillingAddress.LastName': { required: true },
                'BillingAddress.Street': { required: true },
                'BillingAddress.City': { required: true },
                'BillingAddress.PostCode': { required: true },
                'BillingAddress.Country': { required: true }
            },


            GetCheckoutRules: function () { return Object.assign(mmsystem.ui.content.orders.Validation.Rules.EmailRules, mmsystem.ui.content.orders.Validation.Rules.PolicyRules) },
        }
    },

    DomElements: {
        StripeAuthorizeButtonElement: function () {
            return $('#card-payment-btn');
        },
        StripeRequestButtonElement: function () {
            return $('#payment-request-button');
        },
        PayPalButtonElement: function () {
            return $('#paypal-button-container');
        },
        ErrorElement: function () {
            return $('.error-message');
        },

        CreditCardElement: function () {
            return $('#card-element');
        },
        CreditCardErrorElement: function () {
            return $('#card-errors');
        },
        AltPaymentsErrorElement: function () {
            return $('#alt-payments-errors');
        },
        ServerErrorElementClass: function () {
            return 'server-error-msg';
        },

        DisableAuthorizeButton: function () {
            if (!this.StripeAuthorizeButtonElement().is('[disabled=disabled]'))
                this.StripeAuthorizeButtonElement().attr("disabled", "disabled");
        },
        EnableAuthorizeButton: function () {
            if (this.StripeAuthorizeButtonElement().is('[disabled=disabled]'))
                this.StripeAuthorizeButtonElement().removeAttr("disabled");
        },

        CompleteOrderCheckoutButton: function () {
            return $('.complete-order-step-checkout');
        },

        CompleteOrderDetailsButton: function () {
            return $('.complete-order-step-details');
        },

        CompleteOrderPaymentButton: function () {
            return $('.complete-order-step-payment');
        },

        SubmitEnquireButton: function () {
            return $('#send-enquiry');
        },

        DeliveryRestrictionElements: function () {
            return $('.delivery-restriction');
        },

        // Form Fields ----------------------------------
        Form: {
            GetById: function (id) {
                return $('form#' + id);
            },
            GetName: function (field) {
                $(field).attr('name');
            },
            GetContactInfoForm: function () {
                return this.GetById('form-contact-info');
            },
            GetOrderDetailsForm: function () {
                return this.GetById('form-order-address');
            },
            GetOrderPaymentsForm: function () {
                return this.GetById('form-order-billing');
            },
            FindCountryCode: function (element) {
                return element.closest('.select').find('.country-option[data-country-name="' + element.val() + '"]').data('value');
            },
            FindDeliveryPriceId: function (element) {
                return element.closest('.select').find('.delivery-price-option[data-delivery-price-title="' + element.val() + '"]').data('value');
            },
            UseShippingAddressForBillingAddress: function () {
                return $('#shipBillSame');
            },
            UseDifferentAddressForBillingAddress: function () {
                return $('#shipBillDiff');
            },
            Email: function () {
                return $('#contactInfoEmail');
            },
            BillingAddress: {
                FirstName: function () {
                    return $('#billingAddFName');
                },
                LastName: function () {
                    return $('#billingAddLName');
                },
                PhoneNumber: function () {
                    return $('#billingAddPhone');
                },
                Company: function () {
                    return $('#billingAddCompany');
                },
                Street: function () {
                    return $('#billingAddress');
                },
                Number: function () {
                    return $('#billingAddress2');
                },
                City: function () {
                    return $('#billingAddCity');
                },
                Country: function () {
                    return $('#billingAddCountry');
                },
                CountryISO: function () {
                    return $('#billingAddCountryISO');
                },
                CountrySelectTitle: function () {
                    return $('#billingCountryElement');
                },
                CountrySelectOption: function () {
                    return $('.billing-country-select .country-option');
                },
                PostCode: function () {
                    return $('#billingAddZip');
                }
                
            },

            DeliveryAddress: {
                FirstName: function () {
                    return $('#shipAddFName');
                },
                LastName: function () {
                    return $('#shipAddLName');
                },
                PhoneNumber: function () {
                    return $('#shipAddPhone');
                },
                Company: function () {
                    return $('#shipAddCompany');
                },
                Street: function () {
                    return $('#shipAddress');
                },
                Number: function () {
                    return $('#shipAddress2');
                },
                City: function () {
                    return $('#shipAddCity');
                },
                Country: function () {
                    return $('#shipAddCountry');
                },
                CountryISO: function () {
                    return $('#shipAddCountryISO');
                },
                CountrySelectTitle: function () {
                    return $('#shipCountryElement');
                },
                CountrySelectContainer: function () {
                    return $('.ship-country-select');
                },
                CountrySelectOption: function () {
                    return this.CountrySelectContainer().find('.country-option');
                },
                DeliveryPrice: function () {
                    return $('#deliveryPrice');
                },
                DeliverySelectTitle: function () {
                    return $('#deliveryMethodElement');
                },
                DeliverySelectOption: function () {
                    return $('.delivery-price-option');
                },
                DeliverySelectContainer: function () {
                    return $('.ship-method-select');
                },
                DeliveryPriceId: function () {
                    return $('#deliveryPriceId');
                },
                PostCode: function () {
                    return $('#shipAddZip');
                },
                SaveForFuture: function () {
                    return $('#saveUserInfo');
                }
            },

            ClearBillingAddress: function () {
                this.BillingAddress.FirstName().val('');
                this.BillingAddress.LastName().val('');
                this.BillingAddress.PhoneNumber().val('');
                this.BillingAddress.Company().val('');
                this.BillingAddress.Street().val('');
                this.BillingAddress.Number().val('');
                this.BillingAddress.City().val('');
                this.BillingAddress.Country().val('');
                this.BillingAddress.CountryISO().val('');
                this.BillingAddress.PostCode().val('');
            },

            UpdateBillingAddress: function (address) {
                this.BillingAddress.FirstName().val(address.FirstName);
                this.BillingAddress.LastName().val(address.LastName);
                this.BillingAddress.PhoneNumber().val(address.PhoneNumber);
                this.BillingAddress.Company().val(address.Company);
                this.BillingAddress.Street().val(address.Street);
                this.BillingAddress.Number().val(address.Number);
                this.BillingAddress.City().val(address.City);
                this.BillingAddress.Country().val(address.Country);
                this.BillingAddress.CountryISO().val(address.CountryISO);
                this.BillingAddress.PostCode().val(address.PostCode);

            },

            GetEnquireData: function () {
                var data = {
                    ContactTypeId: 2,
                    CustomerName: mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.FirstName().val(),
                    Name: mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.LastName().val(),
                    Email: mmsystem.plugins.Basket.Order.User.Email,
                    PhoneNumber: mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.PhoneNumber().val(),
                    Message: mmsystem.ui.content.orders.DomElements.SubmitEnquireButton().data('enquire-message') + ' Country: ' + mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.CountryISO().val() + ' ' + mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.Country().val()
                }

                return data;
            },

            CheckCountry: function (type) {
                //console.log('CheckCountry.. ' + mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.CountryISO().val());
                if (type === 'delivery' && mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.CountryISO().val() !== '') {
                    //console.log('Set country..');
                    mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.CountrySelectTitle().find('.title__text').text(mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.Country().val());
                }
                if (type === 'billing' && mmsystem.ui.content.orders.DomElements.Form.BillingAddress.CountryISO().val() !== '') {
                    mmsystem.ui.content.orders.DomElements.Form.BillingAddress.CountrySelectTitle().find('.title__text').text(mmsystem.ui.content.orders.DomElements.Form.BillingAddress.Country().val());
                }
            },

            CheckDeliveryMethods: function (checkRestrictions) {
                console.log('CheckDeliveryMethods.. ' + mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.CountryISO().val());
                //console.log(mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.CountryISO().val().lenght);
                //Alow only UK delivery
                if (checkRestrictions) {
                    if (mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.CountryISO().val() == 'GB' ||
                        mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.CountryISO().val().length == 0) {
                        mmsystem.ui.content.orders.DomElements.CompleteOrderDetailsButton().removeClass('d-none').show();
                        mmsystem.ui.content.orders.DomElements.DeliveryRestrictionElements().hide();
                        //console.log('hide enquire');
                    } else {
                        mmsystem.ui.content.orders.DomElements.CompleteOrderDetailsButton().hide();
                        mmsystem.ui.content.orders.DomElements.DeliveryRestrictionElements().removeClass('d-none').show();
                        //console.log('show enquire');
                    }
                    
                }

                //Check Shipping Methods availible
                //console.log(data);
                if (mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.CountryISO().val().length > 0) {
                    mmsystem.ui.ajax.OrderGetDeliveryMethods(mmsystem.ui.content.orders.Urls.GetDeliveryMethodsUrl, { orderId: mmsystem.plugins.Basket.Order.Id, countryISO: mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.CountryISO().val() });
                    mmsystem.plugins.AjaxCover.ShowOnButton(mmsystem.ui.content.orders.DomElements.CompleteOrderDetailsButton().attr('id'));
                }
                
            },

            RemoveDeliveryMethods: function () {
                this.DeliveryAddress.DeliveryPrice().val('');
                this.DeliveryAddress.DeliverySelectOption().remove();
            },

            AddDeliveryMethods: function (html) {
                this.DeliveryAddress.DeliverySelectTitle().after(html);
                if (this.DeliveryAddress.DeliverySelectOption().length > 0) {
                    //Add listeners
                    mmsystem.ui.content.orders.Details.AddDeliveryMethodListeners();
                    mmsystem.ui.content.orders.DomElements.CompleteOrderDetailsButton().removeClass('d-none').show();
                    mmsystem.ui.content.orders.DomElements.DeliveryRestrictionElements().hide();
                    mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.DeliverySelectContainer().removeClass('d-none').show();
                } else {
                    mmsystem.ui.content.orders.DomElements.CompleteOrderDetailsButton().hide();
                    mmsystem.ui.content.orders.DomElements.DeliveryRestrictionElements().removeClass('d-none').show();
                    mmsystem.ui.content.orders.DomElements.Form.DeliveryAddress.DeliverySelectContainer().hide();
                }
            },

            RefreshDeliveryMethods: function (html) {
                console.log('RefreshDeliveryMethods...');
                this.RemoveDeliveryMethods();
                this.AddDeliveryMethods(html);
            }
        }
    },

    UpdateOrderFromForm: function () {
        //console.log('UpdateOrderFromForm...');
        if (!mmsystem.plugins.Basket.Order.BillingAddress) {
            //Set Billing Address
            //console.log('BillingAddress null...');
            mmsystem.plugins.Basket.Order.BillingAddress = {};
        }

        if (this.UseSameAddressForShippingAndBilling) {
            var addressId = mmsystem.plugins.Basket.Order.BillingAddress.Id
            mmsystem.plugins.Basket.Order.BillingAddress = mmsystem.plugins.Basket.Order.DeliveryAddress;
            mmsystem.plugins.Basket.Order.BillingAddress.Id = addressId;
            
        } else {
            mmsystem.plugins.Basket.Order.BillingAddress.FirstName = this.DomElements.Form.BillingAddress.FirstName().val();
            mmsystem.plugins.Basket.Order.BillingAddress.LastName = this.DomElements.Form.BillingAddress.LastName().val();
            mmsystem.plugins.Basket.Order.BillingAddress.PhoneNumber = this.DomElements.Form.BillingAddress.PhoneNumber().val();
            mmsystem.plugins.Basket.Order.BillingAddress.Company = this.DomElements.Form.BillingAddress.Company().val();
            mmsystem.plugins.Basket.Order.BillingAddress.Street = this.DomElements.Form.BillingAddress.Street().val();
            mmsystem.plugins.Basket.Order.BillingAddress.Number = this.DomElements.Form.BillingAddress.Number().val();
            mmsystem.plugins.Basket.Order.BillingAddress.City = this.DomElements.Form.BillingAddress.City().val();
            mmsystem.plugins.Basket.Order.BillingAddress.Country = this.DomElements.Form.BillingAddress.Country().val();
            mmsystem.plugins.Basket.Order.BillingAddress.CountryISO = this.DomElements.Form.BillingAddress.CountryISO().val();
            mmsystem.plugins.Basket.Order.BillingAddress.PostCode = this.DomElements.Form.BillingAddress.PostCode().val();
        }
        

    },

    //Stripe Payment Section -----------------

    InitStripePayment: function () {
        //console.log('mmsystem.ui.content.orders.InitStripePayment()');
        this.Settings.Stripe.CardElement = this.DomElements.CreditCardElement().attr('id');
        this.Settings.Stripe.CardErrorElement = this.DomElements.CreditCardErrorElement().attr('id');
        this.Settings.Stripe.RequestButtonElementId = this.DomElements.StripeRequestButtonElement().attr('id');

        //Set Payment Order to Basket
        this.Settings.Order = mmsystem.plugins.Basket.Order;
        mmsystem.payments.stripe.Init(this.Settings);

        this.CheckAndUpdateStripePaymentRequestButton();
        this.AddStripeElementsListeners();
        this.DomElements.DisableAuthorizeButton();

        //console.log(mmsystem.payments.stripe);
    },

    UpdateStripeOrder: function () {
        //console.log('UpdateStripeOrder');
        //Update Stripe User
        //mmsystem.payments.stripe.User = this.User;
        //Update Stripe Order
        mmsystem.payments.stripe.Order = mmsystem.plugins.Basket.Order;
        //console.log(mmsystem.payments.stripe.Order);
    },

    AddStripeElementsListeners: function () {

        //Pay Now Click - Stripe Credit Card
        this.DomElements.StripeAuthorizeButtonElement().click(function (e) {
            //console.log(mmsystem.ui.content.orders.Validation);
            if (mmsystem.ui.content.orders.Validation.Form.valid()) {
                //Update Order
                mmsystem.ui.content.orders.UpdateOrderFromForm();

                //Create Stripe Payment Method and Make Strpe Payment
                mmsystem.ui.content.orders.CreateStripeCardPaymentMethod();
            }
            
            
        });

        //Payment Request Button - Stripe (Google/Apple Pay)
        mmsystem.payments.stripe.StripePaymentRequestButton.on('click', function (e) {
            //console.log('StripePaymentRequestButton clicked');
            mmsystem.plugins.AjaxCover.ShowOnElement();
            //Clear Payment Method Id
            mmsystem.payments.stripe.StripeFunctions.PaymentMethodId = "";

        });

        mmsystem.payments.stripe.StripePaymentRequest.on('cancel', function () {
            // handle cancel event
            mmsystem.plugins.AjaxCover.Hide();
        });

        //Payment Method - Stripe (Google/Apple Pay)
        mmsystem.payments.stripe.StripePaymentRequest.on('paymentmethod', function (ev) { // can be source or token
            //console.log("StripePaymentRequest.on - paymentmethod: ");
            //console.log(ev);
            // assaign response for future use -------
            mmsystem.payments.stripe.StripeFunctions.IsPaymentResponseEvent = true;
            mmsystem.payments.stripe.StripeFunctions.UpdatePayment = true;
            mmsystem.payments.stripe.StripeFunctions.UpdateBillingFromPaymentMethod = true;
            mmsystem.payments.stripe.StripeFunctions.PaymentResponseEvent = ev;
            mmsystem.payments.stripe.StripeFunctions.PaymentMethodId = ev.paymentMethod.id;

            //Make Strpe Payment (add payment method to intent)
            mmsystem.ui.content.orders.MakeStripePayment();

        });

        //Payment Method - Card
        mmsystem.payments.stripe.EventEmitter.on('CreatePaymentMethodComplete', function (result) {
            //console.log('CreatePaymentMethodComplete...');
            if (result.error) {
                // Inform the user if there was an error
                mmsystem.payments.stripe.ShowErrorElement(result.error.message);
            } else {
                // Send the source to your server
                mmsystem.payments.stripe.HideErrorElement();

                // Insert the token ID into the form so it gets submitted to the server
                mmsystem.payments.stripe.StripeFunctions.PaymentMethodId = result.paymentMethod.id;
                // Setup PaymentType (Stripe)
                mmsystem.payments.stripe.StripeFunctions.PaymentType = mmsystem.payments.stripe.StripeFunctions.ConstPaymentTypes.Stripe;

                //Make Strpe Payment 
                mmsystem.payments.stripe.StripeFunctions.ConfirmPayment = true;
                mmsystem.payments.stripe.StripeFunctions.UpdatePayment = true;
                mmsystem.payments.stripe.StripeFunctions.UpdateBillingFromPaymentMethod = true;
                mmsystem.ui.content.orders.MakeStripePayment();
            }
        });

        //Ajax - Stripe Payment
        mmsystem.payments.stripe.ajax.EventEmitter.on("paymentStripeComplete", function (param) {
            //console.log('mmsystem.payments.stripe.ajax.EventEmitter: paymentStripeComplete...');
            //console.log(param);
            // result = SimpleObjectResult { Type = ResultType.Success, Message = $"Order  saved", Object = new { Order = DBOrder.GetSerializableObject() } } success - 1, error - 2
            var result = param.responseJSON;
            //MissionSystem.CustomScripts.Utilities.HideAjaxCover();
            mmsystem.plugins.AjaxCover.Hide();
            mmsystem.ui.content.orders.HandleStripePaymentAjaxResult(result);
            mmsystem.ui.content.orders.IsStripeRequestInProgress = false;

        });
        //Stripe Card on change
        mmsystem.payments.stripe.EventEmitter.on("stripeCardDetailsChanged", function (param) {
            mmsystem.ui.content.orders.DomElements.EnableAuthorizeButton();
        });
    },

    CheckAndUpdateStripePaymentRequestButton: function () {
        //Check Stripe PaymentRequest
        this.UpdateStripeOrder();
        mmsystem.payments.stripe.CreatePaymentRequest();
        mmsystem.payments.stripe.CreatePaymentRequestButton();
    },

    CreateStripeCardPaymentMethod: function () {
        //console.log('ProcessStripePayment ...');
        //Update Stripe Order
        this.UpdateStripeOrder();
        mmsystem.payments.stripe.CreatePaymentMethod('card');
        
    },

    //Call Ajax StripePayment -------
    MakeStripePayment: function () {

        //MissionSystem.CustomScripts.Utilities.ShowAjaxCover($('.loading-stripe-request-btn'));
        //MissionSystem.CustomScripts.Utilities.ShowAjaxCover($('.loading-stripe-card'));
        mmsystem.plugins.AjaxCover.ShowOnElement();
        mmsystem.ui.content.orders.IsStripeRequestInProgress = true;

        mmsystem.payments.stripe.ajax.MakePayment({
            Order: mmsystem.plugins.Basket.Order,
            StripeModel: {
                PaymentMethodId: mmsystem.payments.stripe.StripeFunctions.PaymentMethodId,
                PaymentIntentId: mmsystem.payments.stripe.StripeFunctions.PaymentIntentId,
                LiveMode: mmsystem.payments.stripe.StripeFunctions.IsLive,
                PaymentType: mmsystem.payments.stripe.StripeFunctions.PaymentType,
                ConfirmPayment: mmsystem.payments.stripe.StripeFunctions.ConfirmPayment,
                UpdatePayment: mmsystem.payments.stripe.StripeFunctions.UpdatePayment,
                UpdateBillingFromPaymentMethod: mmsystem.payments.stripe.StripeFunctions.UpdateBillingFromPaymentMethod
            }
        });
    },

    //Stripe Result
    HandleStripePaymentAjaxResult: function (result) {
        //console.log("HandleStripePaymentAjaxResult ...");
        //console.log(result);
        if (result && result.Type == 1) {
            //console.log("show success");

            //Reset
            //mmsystem.payments.stripe.HideErrorElement();
            mmsystem.payments.stripe.StripeFunctions.ConfirmPayment = false;
            mmsystem.payments.stripe.StripeFunctions.UpdatePayment = false;
            mmsystem.payments.stripe.StripeFunctions.UpdateBillingFromPaymentMethod = false;

            if (mmsystem.payments.stripe.StripeFunctions.IsPaymentResponseEvent === true)
                mmsystem.payments.stripe.StripeFunctions.PaymentResponseEvent.complete('success');

            var requiresAction = false;
            var requiresPaymentMethod = false;
            var paymentIntentClientSecret = "";
            var paymentIntentId = "";
            var succeeded = false;

            if (result.Object) {

                requiresAction = result.Object.requires_action;
                paymentIntentClientSecret = result.Object.payment_intent_client_secret;
                paymentIntentId = result.Object.payment_intent_id;
                requiresPaymentMethod = result.Object.requires_payment_method;
                succeeded = result.Object.succeeded;

            }

            if (succeeded) {
                //console.log('Stripe Payment success');
                //MissionSystem.CustomScripts.Utilities.ShowAjaxCover();
                mmsystem.plugins.AjaxCover.ShowOnElement();
                //console.log('Redirect to: ' + mmsystem.ui.content.orders.Urls.CompleteOrderUrl);
                window.location.replace(mmsystem.ui.content.orders.Urls.CompleteOrderUrl);
            }

            if (requiresAction) {
                //console.log('requiresAction');
                // Let Stripe Handle Additional Actions -------
                mmsystem.payments.stripe.StripePayment.handleCardAction(paymentIntentClientSecret).then(function (result) {
                    if (result.error) {
                        // Inform the user if there was an error
                        mmsystem.payments.stripe.ShowErrorElement(result.error.message);
                    } else {
                        // Save PaymentIntent Id
                        mmsystem.payments.stripe.StripeFunctions.PaymentIntentId = result.paymentIntent.id;

                        // Call Stripe Payment again ----
                        mmsystem.payments.stripe.StripeFunctions.ConfirmPayment = true;
                        mmsystem.ui.content.orders.MakeStripePayment();
                    }
                });
            }
            else if (requiresPaymentMethod) {
                //console.log('requiresPaymentMethod');
                // Save PaymentIntent Id
                mmsystem.payments.stripe.StripeFunctions.PaymentIntentId = paymentIntentId;
                //Wait for PaymentMethod created event 
            }


        } else {
            //console.log("show error");

            if (result && result.Message)
                mmsystem.payments.stripe.ShowErrorElement(result.Message);

            if (mmsystem.payments.stripe.StripeFunctions.IsPaymentResponseEvent === true)
                mmsystem.payments.stripe.StripeFunctions.PaymentResponseEvent.complete('fail');

            if (mmsystem.ui.content.orders.IsServerError) {
                //MissionSystem.CustomScripts.Utilities.ShowAjaxCover();
                //mmsystem.payments.stripe.ShowErrorElement(MissionSystem.CustomScripts.Utilities.GetLocalisedStringValue("serverError", this.LocalisedStrings));
            } else {
                //mmsystem.payments.stripe.ShowErrorElement(MissionSystem.CustomScripts.Utilities.GetLocalisedStringValue("paymentErr2", this.LocalisedStrings));
            }
        }
    }
};


//Node exports
module.exports = mmsystem.ui.content.orders;

//Export Globals
//window.mmsystem.ui.content.orders = mmsystem.ui.content.orders;

// Hot Module Accept
if (module.hot) {
    module.hot.accept();
}
